import * as React from "react";

const SvgComponent = ({ color = "#000", ...props }) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      opacity={0.6}
      cx={9}
      cy={9}
      r={8}
      stroke={color}
      strokeWidth={1.5}
    />
    <circle
      opacity={0.6}
      cx={9}
      cy={9}
      r={4}
      stroke={color}
      strokeWidth={1.5}
    />
  </svg>
);

export default SvgComponent;